export const PDPAPPLYNOWTAGGING = {
    "cardImageHero": "Card Image|Hero",
    "applyNowHero": "Apply Now|Hero",
    "cardImageStickyNav": "Card Image|Sticky Nav",
    "applyNowStickyNav": "Apply Now|Sticky Nav",
    "cardArtBodyCRS003": "Card Image|Body-Shell Fuel Rewards Mastercard",
    "cardArtBodyCRS0031": "Card Image|Body-Shell Fuel Rewards Card",
    "applyNowBodyCRS003": "Apply Now|Body-Shell Fuel Rewards Mastercard",
    "applyNowBodyCRS0031": "Apply Now|Body-Shell Fuel Rewards Card",
    "cardArtCompare003": "Card Image|COMPARE SHELL CREDIT CARDS-Shell Fuel Rewards Mastercard",
    "cardArtCompare0031": "Card Image|COMPARE SHELL CREDIT CARDS-Shell Fuel Rewards Card",
    "applyNowCompare003": "Apply Now|COMPARE SHELL CREDIT CARDS-Shell Fuel Rewards Mastercard",
    "applyNowCompare0031": "Apply Now|COMPARE SHELL CREDIT CARDS-Shell Fuel Rewards Card",
    "cardArtCompare0041": "Card Image|COMPARE CARDS-My Best Buy Credit Card",
    "cardArtCompare0042": "Card Image|COMPARE CARDS-My Best Buy Visa Card",
    "applyNowCompare0041": "Apply Now|COMPARE CARDS-My Best Buy Credit Card",
    "applyNowCompare0042": "Apply Now|COMPARE CARDS-My Best Buy Visa Card",
    "cardArtCompare0052": "Card Image|COMPARE CARDS-Macy's Credit Card",
    "cardArtCompare0053": "Card Image|COMPARE CARDS-Macy's American Express Card",
    "applyNowCompare0052": "Apply Now|COMPARE CARDS-Macy's Credit Card",
    "applyNowCompare0053": "Apply Now|COMPARE CARDS-Macy's American Express Card",
    "applyNowBodyCRS": "Apply Now|Body",
    "applyNowBodyOthers": "Apply Now|Body",
    "cardArtBodyCRS": "Card Image|Body",
    "cardArtBodyOthers": "Card Image|Body"
}
